module.exports = __webpack_public_path__ + "img/117.240f11ea.svg";